import { deleteNotificationAllDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteNotificationAllCallable = getCallable(
  deleteNotificationAllDefinition,
);
